import React from "react";
// javascript plugin used to create scrollbars on windows
import { Route, Switch } from "react-router-dom";

import Navigation from "components/Navbars/Navigation.js";
import routes from "routes.js";
import { Container, Button, Row, Col, Modal,ModalBody,ModalFooter } from "reactstrap";

class Auth extends React.Component {
  constructor(props) {
    super(props);        
  }  


  render() {
    return (
      
        <div className="content-login">
          <div className="img-bg"></div>
          <Navigation />
            <Container className="margin-auth">
              <Switch >
                  {routes.map((prop, key) => {
                      return (
                      <Route
                          path={prop.layout + prop.path}
                          component={prop.component}
                          key={key}
                      />
                      );
                  })}
              </Switch>
            </Container>
        </div>         
    );
  }
}

export default Auth;
